import { useRecordsRealtime } from "@/hooks/useRecordsRealtime";

export const RealtimeUpdates = () => {
  // Этот компонент не рендерит ничего, он только подписывается на обновления
  useRecordsRealtime();
  return null;
};